<template>
    <section class="section header-landing-section white">
        <div class="container">
            <h2 class="title is-spaced">{{ t('meclee-ui.landings.business.tasks_does.title') }}</h2>

            <div class="columns">
                <div class="column is-4">
                    <img :src="TasksDoesImg" loading="lazy" />
                </div>
                <div class="column is-8">
                    <p>{{ t(`meclee-ui.landings.business.tasks_does.content.0`) }}</p>
                    <p>{{ t('meclee-ui.landings.business.tasks_does.content.1') }}</p>
                    <p>
                    <ul class="is-stylized">
                        <li v-for="n in 5"
                            :key="n"
                        >
                          <template v-if="n >= 2">
                            {{ t(`meclee-ui.landings.business.tasks_does.content.${n}`) }}
                          </template>
                        </li>
                    </ul>
                    </p>
                    <p>{{ t('meclee-ui.landings.business.tasks_does.content.6')
                    }}</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import TasksDoesImg from "../../assets/images/business-2.jpg";
const { t } = useI18n();
</script>
